import { Box, Paper } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled(Box)<{ $hidePaperWhenBannerPresent: boolean }>`
  display: flex;
  height: 100vh;
  justify-content: ${({ $hidePaperWhenBannerPresent }) => ($hidePaperWhenBannerPresent ? 'flex-start' : 'center')};
  @media (max-width: 1200px) {
    justify-content: center;
  }
`;

export const PaperStyled = styled(Paper)<{ $hidePaperWhenBannerPresent: boolean }>`
  width: ${({ $hidePaperWhenBannerPresent }) => ($hidePaperWhenBannerPresent ? '100%' : '50%')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: ${({ $hidePaperWhenBannerPresent }) => ($hidePaperWhenBannerPresent ? 'flex-start' : 'center')};
  padding: 20px 120px 34px 96px;

  @media (max-width: 1200px) {
    width: 50%;
    align-items: center;
    padding: 20px 20px 34px 20px;
  }
  @media (max-width: 760px) {
    width: 100%;
  }
`;

export const ContentStyled = styled.div`
  margin-top: 35px;
`;

export const FooterStyled = styled.div`
  text-align: left;
  width: 100%;
  @media (max-width: 1200px) {
    text-align: center;
  }
`;

export const BannerStyled = styled.div`
  display: inline-flex;
  img {
    height: 100vh;
  }

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const BannerTextMobile = styled.div`
  text-align: center;
  @media (min-width: 1201px) {
    display: none;
  }
`;

export const ContentWrapper = styled.div<{ banner: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ banner }) => (banner ? 'flex' : 'center')};
  @media (max-width: 1200px) {
    align-items: center;
  }
`;
